(() => {
  const photos = new Map();
  let zoomRequest = 0;

  function loadPhoto(url) {
    if (photos.has(url)) return photos.get(url);
    const pending = new Promise((resolve, reject) => {
      const photo = new Image();
      photo.decoding = 'async';
      photo.onload = async () => {
        if (photo.decode) await photo.decode().catch(() => {});
        resolve(photo);
      };
      photo.onerror = reject;
      photo.src = url;
    });
    photos.set(url, pending);
    pending.catch(() => photos.delete(url));
    return pending;
  }

  function getDialog() {
    let dialog = document.querySelector('.fg-lightbox');
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'fg-lightbox';
    dialog.innerHTML = '<button type="button"></button><img decoding="async">';
    document.body.append(dialog);
    const close = dialog.querySelector('button');
    close.textContent = document.documentElement.lang.startsWith('en') ? 'Close' : 'Cerrar';
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => { zoomRequest += 1; });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right ||
          event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    return dialog;
  }

  function initFecoPhotos(root = document) {
    root.querySelectorAll('.fg-wine-gallery').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const track = gallery.querySelector('.fg-wine-slides');
      const status = gallery.querySelector('[aria-live]');
      const count = track.querySelectorAll('figure').length;
      const index = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      gallery.querySelectorAll('[data-direction]').forEach(button => {
        button.addEventListener('click', () => track.scrollTo({
          left: ((index() + Number(button.dataset.direction) + count) % count) * track.clientWidth,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        }));
      });
      track.addEventListener('scroll', () => {
        status.textContent = `${Math.min(count, index() + 1)} / ${count}`;
      }, {passive: true});
      gallery.querySelectorAll('figure img').forEach(img => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'fg-photo-zoom';
        button.setAttribute('aria-label', `${document.documentElement.lang.startsWith('en') ? 'Enlarge' : 'Ampliar'}: ${img.alt}`);
        img.before(button);
        button.append(img);
        const fullUrl = () => img.dataset.fullSrc || img.currentSrc || img.src;
        // Warm only the image the visitor is about to open, not every bottle.
        const warm = () => {
          const connection = navigator.connection;
          if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;
          loadPhoto(fullUrl()).catch(() => {});
        };
        button.addEventListener('pointerenter', warm);
        button.addEventListener('focus', warm);
        button.addEventListener('pointerdown', warm, {passive: true});
        button.addEventListener('click', () => {
          const dialog = getDialog();
          const full = dialog.querySelector('img');
          const request = ++zoomRequest;
          // Show the cached on-page image while decoding the full-size original.
          full.src = img.currentSrc || img.src;
          full.alt = img.alt;
          full.setAttribute('aria-busy', 'true');
          dialog.setAttribute('aria-label', img.alt);
          if (!dialog.open) dialog.showModal();
          loadPhoto(fullUrl()).then(photo => {
            if (!dialog.open || request !== zoomRequest) return;
            full.src = photo.src;
            full.setAttribute('aria-busy', 'false');
          }).catch(() => {
            if (request === zoomRequest) full.setAttribute('aria-busy', 'false');
          });
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFecoPhotos());
  } else {
    initFecoPhotos();
  }
  document.addEventListener('shopify:section:load', event => initFecoPhotos(event.target));
})();
